import React, { Dispatch, SetStateAction, useState } from 'react';
import { Dropdown } from 'react-bootstrap';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { User } from '../../models/user.model';
import { Company } from '../../models/company.model';
import { Contact } from '../../models/contact.model';
import { legendValid } from '../../tools/legend.data.entry.tool';
import { contactFormat } from '../../scripts/format.value.script';
import { modalShow } from '../../tools/modal.tool';

import AppLegend from './Legend';
import AppModalContactCreate from '../modal/ModalContactCreate';

export interface AppInputContactProps {
  userLoggedIn: User,
  companyForUser: Company,
  contactsForCompany: Contact[],
  contact: {value: string, valid: boolean, object: any},
  setContact: Dispatch<SetStateAction<{value: string, valid: boolean, object: any}>>,
  setLanguage?: Dispatch<SetStateAction<{value: string, valid: boolean}>>,
  setQrTtype?: Dispatch<SetStateAction<{value: string, valid: boolean}>>,
  loadContactsForCompany: Function
};

const AppInputContact: React.FunctionComponent<AppInputContactProps> = ({userLoggedIn, companyForUser, contactsForCompany, contact, setContact, setLanguage, setQrTtype, loadContactsForCompany}) => {
  const {lang} = StateLanguage()

  const [search, setSearch] = useState<{text: string, list: Contact[]}>({text: '', list: []})

  const handleChangeSearch = (event: React.ChangeEvent <HTMLFormElement | HTMLInputElement>) => {
    let text: string = event.target.value
    let list: Contact[] = []

    if (text.length > 0) {
      for (let contact of contactsForCompany) {
        let string: string = (contact.type === 'person') ? (`${contact.data.first_name} ${contact.data.last_name}`).toLowerCase() : contact.data.name.toLowerCase()
        if (string.indexOf(text.toLowerCase()) !== -1) {
          list.push(contact)
        }
      }
    } else {
      list = contactsForCompany
    }

    setSearch({text: text, list: list})
  }

  const handleChangeContact = (item: Contact) => {
    setContact({value: item.data.id, valid: true, object: item})
    legendValid('legend-customer-required')

    if (setLanguage) {
      setLanguage({value: item.data.language, valid: true})
      legendValid('legend-language-required')
    }

    if (setQrTtype) {
      setQrTtype({value: item.data.qr_type, valid: true})
      legendValid('legend-qr-type-required')
    }
  }

  const executeShowModalContactCreate = () => {
    modalShow('modal-contact-create')
  }

  function uploadDropdown() {
    setSearch({text: '', list: contactsForCompany})
  }

  return (
    <>
      <div className="d-flex align-self-center">
        <div className="flex-grow-1 me-2">
          <Dropdown onToggle={uploadDropdown}>
            <Dropdown.Toggle variant="select2 select2-container select2-container--bootstrap5 select2-container--below select2-container--focus select2-container--open w-100 p-0">
              <span className="selection">
                <span className="select2-selection select2-selection--single form-select form-select-solid">
                  <span className="select2-selection__rendered" role="textbox">
                    {contact.valid ? contactFormat(contact.object) : lang.labels.selectOption}
                  </span>
                </span>
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu variant="select2-container select2-container--bootstrap5 select2-container--open w-100">
              <span className="select2-dropdown select2-dropdown--below">
                <span className="select2-search select2-search--dropdown">
                  <input className="select2-search__field" type="text" autoComplete="off" name="contact" value={search.text} onChange={handleChangeSearch} />
                </span>
                <span className="select2-results">
                  <ul className="select2-results__options" role="listbox">
                    { search.list.length > 0
                      ?
                      <>
                        { search.list.map (( (item, index) => { return (
                          <li key={index} className={`select2-results__option select2-results__option--selectable ${item.data.id === contact.value && "select2-results__option--selected"}`} role="option" aria-selected={item.data.id === contact.value}>
                            <Dropdown.Item bsPrefix="select2-results__option__text" onClick={() => handleChangeContact(item)}>{contactFormat(item)}</Dropdown.Item>
                          </li>
                        )}))}
                      </>
                      :
                      <li className="select2-results__option select2-results__message" role="alert">{lang.labels.noResultsFound}</li>
                    }
                  </ul>
                </span>
              </span>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="flex-shrink-0">
          <button className="btn btn-sm btn-light-primary h-100" type="button" onClick={executeShowModalContactCreate}>
            <div className="d-flex align-items-center">
              <span className="svg-icon svg-icon-3 ms-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="black" />
                  <rect x="10.8891" y="17.8033" width="12" height="2" rx="1" transform="rotate(-90 10.8891 17.8033)" fill="black" />
                  <rect x="6.01041" y="10.9247" width="12" height="2" rx="1" fill="black" />
                </svg>
              </span>
              {lang.labels.addContact}
            </div>
          </button>
        </div>
      </div>
      <div className="form-text text-justify">{lang.labels.searchSelectContact}</div>
      <AppLegend attribute={{check: contact.valid, name: "contact", index: null, sub_index: null}} container={{valid: false, required: true, identical: false, exists: false}}></AppLegend>
      <AppModalContactCreate userLoggedIn={userLoggedIn} companyForUser={companyForUser} setContact={setContact} setLanguageDocument={setLanguage} setQrTtypeDocument={setQrTtype} loadContactsForCompany={loadContactsForCompany}></AppModalContactCreate>
    </>
  )
}

export default AppInputContact;
